// Classic › home page registration spotlight (Website › Design ›
// Registration's "Home page spotlight", owner October 28). The league's open
// public registrations from core's openForms, open ones first, then upcoming
// ones ("Opens …", linking to their details). Renders nothing when none.
// Mobile first: one column, two from `md`; at most four cards, then a link to
// the Register list.
//
// `relative` on the section is load-bearing: the home grid is pulled up over
// the positioned hero banner, so anything not positioned paints under it (the
// other sections get their stacking context from `backdrop-blur-md`).

import { Link } from 'react-router-dom'
import { useLabels } from '@/site/core/labels'
import type { OpenFormVM } from '@/site/core/pages/home/types'

const MAX = 4

export function RegistrationSpotlight({ forms }: { forms: OpenFormVM[] }) {
  const t = useLabels().ui.registration
  if (forms.length === 0) return null
  return (
    <section aria-labelledby="home-registration-spotlight" className="relative mb-4 sm:mb-5">
      <div className="flex items-center justify-between gap-3 mb-3">
        <h2 id="home-registration-spotlight" className="text-lg sm:text-xl font-['Montserrat'] font-black text-white uppercase tracking-tight">
          {t.listTitle}
        </h2>
        {forms.length > MAX && (
          <Link to="/register" className="text-sm font-bold text-primary hover:underline">{t.allRegistrations}</Link>
        )}
      </div>
      <ul className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {forms.slice(0, MAX).map((f) => {
          const action = f.waitlist ? t.joinWaitlist : f.opensLabel ? t.viewDetails : t.viewAction
          return (
            <li key={f.slug} className="bg-bg-secondary border border-secondary/30 rounded-lg p-4 flex flex-col">
              <h3 className="text-base font-['Montserrat'] font-black text-white uppercase tracking-tight leading-tight">{f.title}</h3>
              <p className="mt-1 text-sm text-white/70">
                {[f.price ?? t.free, f.opensLabel ? t.opens(f.opensLabel) : f.closesLabel ? t.closes(f.closesLabel) : null]
                  .filter(Boolean)
                  .join(' · ')}
              </p>
              <div className="mt-3">
                <Link
                  to={f.href}
                  aria-label={`${action}: ${f.title}`}
                  className={
                    f.opensLabel
                      ? 'flex w-full min-h-[44px] items-center justify-center rounded-md border border-white/20 px-4 font-bold text-white hover:border-white/40 transition-all'
                      : 'flex w-full min-h-[44px] items-center justify-center rounded-md bg-primary px-4 font-bold text-black hover:bg-primary/90 transition-all'
                  }
                >
                  {action}
                </Link>
              </div>
            </li>
          )
        })}
      </ul>
    </section>
  )
}
